import { useMemo } from 'react';
import { mediaManagerCreateFolderActions, mediaManagerFileClick } from '@wix/bi-logger-media-data/v2';
import { bi } from '../../../services/loggers/bi';
import {
  ClickOrigin,
  CreateFolderAction,
} from '../../hoc/bi/withTrackSiteFilesAnalytics/withTrackSiteFilesAnalytics.types';

export const useTrackSiteFilesAnalytics = () =>
  useMemo(
    () => ({
      trackBreadcrumbsClick: (fileId, mediaType) => bi.logger().report(mediaManagerFileClick({ fileId, mediaType })),
      trackFolderCreateStart: (origin: ClickOrigin) => {
        bi.logger().report(
          mediaManagerCreateFolderActions({
            fileId: '',
            clickOrigin: origin,
            target: CreateFolderAction.Started,
          }),
        );
      },
      trackFolderCreated: (folderId: string, origin: ClickOrigin) => {
        bi.logger().report(
          mediaManagerCreateFolderActions({
            fileId: folderId,
            clickOrigin: origin,
            target: CreateFolderAction.Created,
          }),
        );
      },
    }),
    [],
  );
